import React, { Fragment, useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import Popover from '@material-ui/core/Popover'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const MAX_TOOLTIP = 100

const getTooltip = text => {
  if (text.length > MAX_TOOLTIP) {
    return text.substring(0, MAX_TOOLTIP) + '...'
  }
  return text
}

const useStyles = makeStyles(theme => ({
  root: {
    width: 500
  },
  icon: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(1)
  },
  typography: {
    padding: theme.spacing(2)
  }
}))

export default ({ label, text, icon, onClick }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleClick = event => {
    setShowTooltip(false)

    if (!onClick) {
      setAnchorEl(anchorEl ? null : event.currentTarget)
    } else {
      onClick()
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const popoverId = openPopover ? 'notes-popper' : undefined

  return (
    <Fragment>
      {text && text.length && (
        <Fragment>
          <Tooltip
            open={showTooltip}
            title={getTooltip(text)}
            onOpen={() => setShowTooltip(!openPopover)}
            onClose={() => setShowTooltip(false)}
          >
            <IconButton
              className={classes.icon}
              aria-label={label}
              color='primary'
              onClick={handleClick}
            >
              {icon}
            </IconButton>
          </Tooltip>
          <Popover
            id={popoverId}
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <div className={classes.root}>
              <Paper>
                <Typography className={classes.typography}>{text}</Typography>
              </Paper>
            </div>
          </Popover>
        </Fragment>
      )}
    </Fragment>
  )
}
